import Immutable from 'seamless-immutable';

import actions from './actions';

const initState = Immutable.from({
	branches: null
});

export default function branchesReducer(state = initState, { type, payload }) {
	switch (type) {
		case actions.BRANCHES_SET: {
			return Immutable.set(state, 'branches', payload.branches);
		}
		default: {
			return state;
		}
	}
}
